import createVueComponent from '../createVueComponent';

const ChevronRight = createVueComponent('ChevronRightIcon', [
  ['polyline', { points: '9 18 15 12 9 6' }],
]);

export default ChevronRight;
